export function formatMoney(value, currency = 'INR') {
  if (value === null || value === undefined) {
    return null;
  }

  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency,
    maximumFractionDigits: 0
  }).format(value);
}

export function formatDurationMonths(months) {
  if (!months || Number.isNaN(months)) {
    return 'Duration not specified';
  }

  const years = Math.floor(months / 12);
  const remainingMonths = months % 12;

  if (years && remainingMonths) {
    return `${years}y ${remainingMonths}m`;
  }
  if (years) {
    return `${years} year${years > 1 ? 's' : ''}`;
  }
  return `${remainingMonths} month${remainingMonths > 1 ? 's' : ''}`;
}

export function locationLabel(entity) {
  return [entity.city, entity.state, entity.country].filter(Boolean).join(', ') || null;
}
